"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractManager = void 0;
const ethers_1 = require("ethers");
const transaction_1 = require("../transaction");
class ContractManager extends transaction_1.TransactionManager {
    constructor() {
        super();
        this.contractMap = new Map();
    }
    getContract(params) {
        let contractInstance = this.contractMap.get(this.getKey(params.address, params.networkId));
        if (!contractInstance) {
            contractInstance = new ethers_1.ethers.Contract(params.address, params.abi, params.provider);
        }
        return contractInstance;
    }
    getKey(address, networkId) {
        if (!address || !networkId) {
            throw new Error("address and networkId are manadatory parameters");
        }
        return `${address.toLowerCase()}_${networkId}`;
    }
}
exports.ContractManager = ContractManager;
